// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qyIxQ","productName":"Table_productName__ijW5i"};